export type RatecheckEvent =
  | "ratecheck_started"
  | "sample_cleared"
  | "deal_completed"
  | "gap_calculated"
  | "cited_print_viewed"
  | "stay_selected"
  | "switch_selected"
  | "bank_script_viewed"
  | "pack_started"
  | "pack_submitted"
  | "pack_submit_attempt"
  | "pack_submit_success"
  | "pack_submit_failure"
  | "lead_success"
  | "lead_failure";

export type RatecheckProps = {
  occupancy?: "owner" | "investment";
  lvrBand?: string;
  gapBand?: "none" | "close" | "review" | "overpaying";
  lenderCategory?: "major" | "other";
  deviceClass?: "phone" | "tablet" | "desktop";
  referralSource?: string;
};

const MAJORS = new Set(["CBA", "Westpac", "NAB", "ANZ"]);

export function gapBand(gap: number | null | undefined): RatecheckProps["gapBand"] {
  if (gap == null) return "none";
  if (Math.abs(gap) < 0.15) return "close";
  if (gap < 0.4) return "review";
  return "overpaying";
}

export function lenderCategory(lender: string): RatecheckProps["lenderCategory"] {
  return MAJORS.has(lender) ? "major" : "other";
}

export function deviceClass(): RatecheckProps["deviceClass"] {
  if (typeof window === "undefined") return "desktop";
  const w = window.innerWidth;
  if (w < 640) return "phone";
  if (w < 980) return "tablet";
  return "desktop";
}

function referralSource(): string | undefined {
  try {
    const host = document.referrer ? new URL(document.referrer).host : "";
    return host || undefined;
  } catch {
    return undefined;
  }
}

/** Privacy-conscious events. Never send name, email, mobile, or a full address. */
export function track(name: RatecheckEvent, props: RatecheckProps = {}): void {
  const payload = {
    event: name,
    occupancy: props.occupancy,
    lvrBand: props.lvrBand,
    gapBand: props.gapBand,
    lenderCategory: props.lenderCategory,
    deviceClass: props.deviceClass ?? deviceClass(),
    referralSource: props.referralSource ?? referralSource(),
  };
  const dataLayer = (window as Window & { dataLayer?: Record<string, unknown>[] }).dataLayer;
  if (Array.isArray(dataLayer)) dataLayer.push(payload);
}

export function campaignFromPage(): {
  utm?: { source?: string; medium?: string; campaign?: string };
  referrerHost?: string;
} {
  const q = new URLSearchParams(window.location.search);
  const utm = {
    source: q.get("utm_source") || undefined,
    medium: q.get("utm_medium") || undefined,
    campaign: q.get("utm_campaign") || undefined,
  };
  return {
    utm: utm.source || utm.medium || utm.campaign ? utm : undefined,
    referrerHost: referralSource(),
  };
}
